module.exports = __webpack_public_path__ + "static/media/CHALO Café - Logo.1d1d67da.png";